import { render, staticRenderFns } from "./BalanceSettingsModal.vue?vue&type=template&id=7313b839&scoped=true&"
import script from "./BalanceSettingsModal.vue?vue&type=script&lang=js&"
export * from "./BalanceSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./BalanceSettingsModal.vue?vue&type=style&index=0&id=7313b839&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7313b839",
  null
  
)

export default component.exports